export default "__VITE_ASSET__BVIbLXoW__"